<template>
  <section class="c-section c-section--legal py-5">
    <div class="container">
      <b-skeleton-wrapper :loading="contextLoading">
        <template #loading>
          <div class="row gy-3 justify-content-center">
            <div class="col-12 col-lg-8">
              <div class="d-flex justify-content-center">
                <b-skeleton width="80%" height="40px"></b-skeleton>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <b-skeleton width="100%" height="20px"></b-skeleton>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <b-skeleton width="90%" height="20px"></b-skeleton>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <b-skeleton width="80%" height="20px"></b-skeleton>
              </div>
            </div>
          </div>
        </template>

        <div v-if="context.post" class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div>
              <h2 class="fs-50 w-light sec-medium text-center mb-5">
                {{context.post.title}}
              </h2>
              <div v-html="context.post.content"></div>
            </div>
          </div>
        </div>
      </b-skeleton-wrapper>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'politicas-privacidad' });
  },
};
</script>
